import { cn } from '@skupreme/shared/ui';
import { countryFlag } from '../../lib/markets';

/**
 * M2: the country a marketplace logo sells in, as a small flag, ringed in the surface colour (as StatusDot is) so it
 * reads on the light tile and the dark theme's logo tile. Decorative: the mark it sits on names the country in words.
 */
export function CountryFlagBadge({
  country,
  className,
}: {
  country: string;
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      data-country={country}
      className={cn(
        'sk:inline-flex sk:items-center sk:justify-center sk:rounded-sm sk:bg-surface sk:text-[10px] sk:leading-none sk:ring-1 sk:ring-surface',
        className,
      )}
    >
      {countryFlag(country)}
    </span>
  );
}
